<template>
  <ul id="ul_struct">
    <StructureNode v-for="(node, index) in structData" :key="getNodeKey(node, index)" :node="node" :depth="0"
      @onClickItem="$emit('onClickItem', $event)" @onClickExpand="onClickExpand" />
  </ul>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useStructure } from './useStructure.js';
import StructureNode from './StructureNode.vue';

const props = defineProps({
  structData: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['onClickItem', 'onClickExpand']);

const { getNodeKey } = useStructure();

const onClickExpand = (node) => {
  emit('onClickExpand', node);
};

</script>

<style scoped lang="scss" src="./StyleStructure.scss"></style>